module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-pro"
  }, [(!_vm.isDomainGood) ? _c('div', {
    staticClass: "kj-pro-domain"
  }, [_vm._v("砍价活动正在疯狂准备中，请联系客服！"), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("点击进入主页")])]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "kj-pro-mobi"
  }, [_c('div', {
    staticClass: "kj-pro-mobi_cont"
  }, [_c('span', [_vm._v("微信扫一扫参与砍价任务!")]), _vm._v(" "), (_vm.qrcode) ? _c('img', {
    attrs: {
      "src": _vm.qrcode
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.congratulation) ? _c('div', {
    staticClass: "kj-pro-done"
  }, [_c('Congratulation', {
    attrs: {
      "congratulationInf": _vm.congratulationInf,
      "qrcode": _vm.qrcode,
      "shortUrl": _vm.shortUrl,
      "campaignInf": _vm.campaignInf,
      "currentPlay": _vm.currentPlay,
      "bargainInf": _vm.bargainInf,
      "stock": _vm.bargainInf.inventory,
      "hasOrder": _vm.hasOrder,
      "item": _vm.item
    }
  })], 1) : _c('div', {
    staticClass: "kj-pro-cont"
  }, [_c('div', {
    staticClass: "kj-pro-info"
  }, [_c('div', {
    staticClass: "kj-pro-info_title"
  }, [_vm._v("↓"), _c('span', [_vm._v("砍价优惠中")]), _vm._v("↓")]), _vm._v(" "), (_vm.hasOrder) ? _c('button', {
    staticClass: "kj-pro-info_order",
    on: {
      "click": _vm.handleBargainOrderClick
    }
  }, [_vm._v("砍价订单")]) : _vm._e(), _vm._v(" "), (_vm.campaignInf.product_image_url) ? _c('img', {
    staticClass: "kj-pro-info_img",
    attrs: {
      "src": _vm.campaignInf.product_image_url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-info_name"
  }, [_vm._v(_vm._s(_vm.bargainInf.title))]), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-items"
  }, [_c('div', {
    staticClass: "kj-pro-item"
  }, [_c('div', {
    staticClass: "kj-pro-info_pro_sum"
  }, [_vm._v("仅剩 "), _c('Number', {
    attrs: {
      "inventory": _vm.bargainInf.inventory
    }
  }), _vm._v(" 件")], 1), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-info_time"
  }, [_c('CountDown', {
    attrs: {
      "time": _vm.time
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "kj-pro-info_go jsScrollTop",
    on: {
      "click": _vm.handleCommodityInf
    }
  }, [_vm._v("查看商品详情")])]), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-progress"
  }, [_c('div', {
    staticClass: "kj-pro-progress_prices"
  }, [(_vm.can_show_lowest_price) ? _c('div', {
    staticClass: "kj-pro-progress_price_min"
  }, [_vm._v("底价"), _c('span', [_vm._v("￥" + _vm._s((_vm.bargainInf.lowest_price / 100).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-progress_price_max"
  }, [_vm._v("原价￥" + _vm._s((_vm.bargainInf.original_price / 100).toFixed(2)))])]), _vm._v(" "), _c('ProgressBar', {
    staticClass: "kj-pro-progress_bar",
    attrs: {
      "progress": _vm.progress
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-progress_now_price"
  }, [_c('CurrentPrice', {
    attrs: {
      "currentPrice": (_vm.bargainInf.amount_after ? _vm.bargainInf.amount_after : _vm.bargainInf.original_price),
      "currentPriceAvatar": this.currentPriceAvatar
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-activity_cont"
  }, [_c('ActivityContent', {
    attrs: {
      "player": _vm.player,
      "id": _vm.player.playId,
      "terms": _vm.terms
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-recommend"
  }, [_c('div', {
    staticClass: "kj-pro-recommend_title"
  }, [_vm._v("商品详情")]), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-recommend_info",
    domProps: {
      "innerHTML": _vm._s(_vm.bargainInf.product_html)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kj-pro-btns"
  }, [_c('BargainButton', {
    attrs: {
      "item": _vm.item,
      "selectIndex": _vm.index,
      "currentPlay": _vm.currentPlay,
      "campaignInf": _vm.campaignInf,
      "title": _vm.bargainInf.title,
      "imgSrc": _vm.imgSrc,
      "lowestPrice": (_vm.bargainInf.lowest_price / 100).toFixed(2),
      "originPrice": (_vm.bargainInf.original_price / 100).toFixed(2),
      "shortUrl": _vm.short_url,
      "qrcode": _vm.qrcode,
      "hasOrder": _vm.hasOrder,
      "stock": _vm.bargainInf.inventory
    },
    on: {
      "bargainForMysel": _vm.handleBargainForMysel
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29bbabe8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bargainDetail/index.vue
// module id = 282
// module chunks = 0